<template>
  <div id="app" class="app">
    <div class="top-bar">网彩彩票</div>
    <swipe :images="images"></swipe>
    <div class="lottery-wrap border-1px">
      <div class="item-wrap">
        <router-link to="/ssc" class="item">
          <span class="icon ssc"></span>
          <span class="text">双色球</span>
        </router-link>
      </div>
      <div class="item-wrap">
        <router-link to="/dlt" class="item">
          <span class="icon dlt"></span>
          <span class="text">大乐透</span>
        </router-link>
      </div>
      <div class="item-wrap">
        <router-link to="/d3" class="item">
          <span class="icon d3"></span>
          <span class="text">3D</span>
        </router-link>
      </div>
      <div class="item-wrap">
        <router-link to="/k3" class="item">
          <span class="icon k3"></span>
          <span class="text">快3</span>
        </router-link>
      </div>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script type="text/ecmascript-6">
  import swipe from 'components/header/header.vue';
  import { localdata } from 'common/js/data';
  export default {
    name: 'app',
    data() {
      return {
        images: localdata.images
      };
    },
    components: {
      swipe
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "common/stylus/mixin.styl";
  .app
    .top-bar
      width:100%
      height:40px
      font-size:18px
      line-height:40px
      color:#ffffff
      text-align:center
      background-color:#d91d36
    .lottery-wrap
      display:flex
      flex-flow:wrap
      margin-top:10px
      border-1px(rgba(7,17,27,0.1))
      background-color:#fff
      .item-wrap
        padding:15px 0
        width:50%
        height:80px
        border-top:1px solid rgba(7,17,27,0.1)
        .item
          display:block
          width:100%
          height:100%
          color:rgb(7,17,27)
          .icon
            display:inline-block
            width:50px
            height:50px
            margin-right:20px
            margin-left:16px
            background-repeat:no-repeat
            background-size:100% 100%
            vertical-align:top
            &.ssc
              background-image:url("./images/cpIcon1.png")
            &.dlt
              background-image:url("./images/cpIcon4.png")
            &.d3
              background-image:url("./images/cpIcon2.png")
            &.k3
              background-image:url("./images/cpIcon3.png")
          .text
            font-size:18px
            font-weight:700
            line-height:50px
            vertical-align:top
            letter-spacing:4px
          &:nth-of-type(odd)
            border-right:1px solid rgba(7,17,27,0.1)
          &.active
            color:rgb(7,17,27)
</style>



// WEBPACK FOOTER //
// App.vue?46d91f00